<template>
  <div class="app">
    <Hero :page-title="pageTitle" />
    <div class="container">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
    <br /><br /><br />
    <Footer />
  </div>
</template>
<script>
import Hero from "./components/Header/vHero";
import Footer from "./components/Footer/vFooter";
import eventBus from "../tools/eventBus";

export default {
  name: "App",
  components: {
    Hero,
    Footer
  },
  methods: {
    setPageTitle(e) {
      this.pageTitle = e;
    }
  },
  data() {
    eventBus.$on("setPageTitle", this.setPageTitle);
    return {
      pageTitle: ""
    };
  }
};
</script>

<style lang="scss" scoped>
.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.fade {
  &-enter,
  &-leave {
    opacity: 0;

    &-active {
      transition: opacity 0.35s;
    }
  }
}
</style>

<i18n>
{

}
</i18n>
